<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-btn text icon color="green">
            <v-icon @click="$router.go(-1)">mdi-keyboard-backspace</v-icon>
          </v-btn>
          <v-icon v-if="query"></v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="query"
            >Miscellaneous Claims Parameters
            <v-btn text color="primary" @click="query = false" v-if="query">
              Edit
              <v-icon right>mdi-pencil</v-icon>
            </v-btn>
          </v-toolbar-title>
          <v-toolbar-title v-else>Miscellaneous Claims Parameters </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="clmnoform"
                  v-model="miscCLForm.clmNoForm"
                  :label="labels.clmNoForm"
                  item-text="label"
                  item-value="value"
                  data-vv-name="clmNoForm"
                  :data-vv-as="labels.clmNoForm"
                  :error-messages="errors.collect('clmNoForm')"
                  v-validate="'required'"
                  :disabled="query"
                ></v-autocomplete>
                <!-- <v-text-field v-model="miscCLForm.clmNoForm" type="number" :label="labels.clmNoForm" :error-messages="errors.collect('clmNoForm')" data-vv-name="clmNoForm" :data-vv-as="labels.clmNoForm" v-validate="'required|numeric|min_value:0|max_value:9'"  :disabled="query"></v-text-field> -->
              </v-flex>
              <v-flex xs6 v-show="false">
                <cal-picker
                  v-model="miscCLForm.impComDate"
                  :label="labels.impComDate"
                  v-validate="'required|checkDate'"
                  :data-vv-as="labels.impComDate"
                  data-vv-name="impComDate"
                  :error-messages="errors.collect('impComDate')"
                  :max="today"
                  :disabled="query"
                ></cal-picker>
              </v-flex>
              <!-- </v-layout> -->
              <!-- <v-layout row wrap> -->
              <v-flex xs6>
                <v-autocomplete
                  :items="prtILNList"
                  v-model="miscCLForm.newClmPrtILN"
                  :label="labels.newClmPrtILN"
                  item-text="label"
                  item-value="value"
                  data-vv-name="newClmPrtILN"
                  :data-vv-as="labels.newClmPrtILN"
                  :error-messages="errors.collect('newClmPrtILN ')"
                  v-validate="'required'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-show="false">
                <cal-picker
                  v-model="miscCLForm.resTranDate"
                  :label="labels.resTranDate"
                  v-validate="'required|checkDate'"
                  :data-vv-as="labels.resTranDate"
                  data-vv-name="resTranDate"
                  :error-messages="errors.collect('resTranDate')"
                  :disabled="query"
                ></cal-picker>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="prtILNList"
                  v-model="miscCLForm.setClmPrtILN"
                  :label="labels.setClmPrtILN"
                  item-text="label"
                  item-value="value"
                  data-vv-name="setClmPrtILN"
                  :data-vv-as="labels.setClmPrtILN"
                  :error-messages="errors.collect('setClmPrtILN')"
                  v-validate="'required'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="rcvyDateList"
                  v-model="miscCLForm.rcvyDate"
                  :label="labels.rcvyDate"
                  item-text="label"
                  item-value="value"
                  data-vv-name="rcvyDate"
                  :data-vv-as="labels.rcvyDate"
                  :error-messages="errors.collect('rcvyDate')"
                  v-validate="'required'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.frgnCurrRes"
                  v-model="miscCLForm.frgnCurrRes"
                  :error-messages="errors.collect('frgnCurrRes')"
                  data-vv-name="frgnCurrRes"
                  :data-vv-as="labels.frgnCurrRes"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.protExRate"
                  v-model="miscCLForm.protExRate"
                  :error-messages="errors.collect('protExRate')"
                  data-vv-name="protExRate"
                  :data-vv-as="labels.protExRate"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-show="false">
                <v-checkbox
                  :label="labels.prtRIOsRes"
                  v-model="miscCLForm.prtRIOsRes"
                  :error-messages="errors.collect('prtRIOsRes')"
                  data-vv-name="prtRIOsRes"
                  :data-vv-as="labels.prtRIOsRes"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.prtRIPV"
                  v-model="miscCLForm.prtRIPV"
                  :error-messages="errors.collect('prtRIPV')"
                  data-vv-name="prtRIPV"
                  :data-vv-as="labels.prtRIPV"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <!-- </v-layout> -->
              <!-- <v-layout row wrap> -->
              <v-flex xs6 v-show="false">
                <v-autocomplete
                  :items="permInsuffResList"
                  v-model="miscCLForm.permInsuffRes"
                  :label="labels.permInsuffRes"
                  item-text="label"
                  item-value="value"
                  data-vv-name="permInsuffRes"
                  :data-vv-as="labels.permInsuffRes"
                  :error-messages="errors.collect('permInsuffRes')"
                  v-validate="'required'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-show="false">
                <v-checkbox
                  :label="labels.nxtRevDateMand"
                  v-model="miscCLForm.nxtRevDateMand"
                  :error-messages="errors.collect('nxtRevDateMand')"
                  data-vv-name="nxtRevDateMand"
                  :data-vv-as="labels.nxtRevDateMand"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <!-- </v-layout> -->
              <!-- <v-layout row wrap> -->
              <v-flex xs6>
                <v-checkbox
                  :label="labels.autoFacXOLRcvy"
                  v-model="miscCLForm.autoFacXOLRcvy"
                  :error-messages="errors.collect('autoFacXOLRcvy')"
                  data-vv-name="autoFacXOLRcvy"
                  :data-vv-as="labels.autoFacXOLRcvy"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.protAutoFacXOLRcvy"
                  v-model="miscCLForm.protAutoFacXOLRcvy"
                  :error-messages="errors.collect('protAutoFacXOLRcvy')"
                  data-vv-name="protAutoFacXOLRcvy"
                  :data-vv-as="labels.protAutoFacXOLRcvy"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="gstCltGrpList"
                  v-model="miscCLForm.gstCltGrp"
                  :label="labels.gstCltGrp"
                  item-text="label"
                  item-value="value"
                  data-vv-name="gstCltGrp"
                  :data-vv-as="labels.gstCltGrp"
                  :error-messages="errors.collect('gstCltGrp')"
                  v-validate="'required'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <cal-picker
                  v-model="miscCLForm.gstImpDate"
                  :label="labels.gstImpDate"
                  v-validate="'required|checkDate'"
                  :data-vv-as="labels.gstImpDate"
                  data-vv-name="gstImpDate"
                  :error-messages="errors.collect('gstImpDate')"
                  :disabled="query"
                ></cal-picker>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.gstRegBlk"
                  v-model="miscCLForm.gstRegBlk"
                  :error-messages="errors.collect('gstRegBlk')"
                  data-vv-name="gstRegBlk"
                  :data-vv-as="labels.gstRegBlk"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6 v-show="false">
                <v-checkbox
                  :label="labels.updGSTRegNo"
                  v-model="miscCLForm.updGSTRegNo"
                  :error-messages="errors.collect('updGSTRegNo')"
                  data-vv-name="updGSTRegNo"
                  :data-vv-as="labels.updGSTRegNo"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <!-- </v-layout> -->
              <!-- <v-layout row wrap> -->
              <v-flex xs6>
                <v-checkbox
                  :label="labels.protGSTDIT"
                  v-model="miscCLForm.protGSTDIT"
                  :error-messages="errors.collect('protGSTDIT')"
                  data-vv-name="protGSTDIT"
                  :data-vv-as="labels.protGSTDIT"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-divider class="pt-3"></v-divider>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="defDeptList"
                  v-model="miscCLForm.defDept"
                  :label="labels.defDept"
                  item-text="departmentLabel"
                  item-value="department"
                  item-key="department"
                  data-vv-name="defDept"
                  :data-vv-as="labels.defDept"
                  :error-messages="errors.collect('defDept')"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-divider class="pt-3"></v-divider>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ miscCLForm.modifiedName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDate(miscCLForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="!query">
          <v-btn color="error" @click="queryModeSwitch" :loading="submitting"> Cancel<v-icon right dark>mdi-cancel</v-icon> </v-btn>
          <v-btn color="primary" dark @click="doSave" :loading="submitting"> Save Parameters<v-icon right>mdi-content-save</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, removeTime } from '@/utils/date'
import { commonMixins } from '@/mixins/common/commonMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import isAfter from 'date-fns/isAfter'
import clone from 'clone'
export default {
  data() {
    return {
      labels: {
        clmNoForm: 'Claims No. Format',
        impComDate: 'Implementation Commencement Date',
        newClmPrtILN: 'Default Printing of New Claims Face Sheet - I/L/N',
        resTranDate: 'Claims Reserve Transfer Date',
        setClmPrtILN: 'Default Printing of Settled Claims Face Sheet - I/L/N',
        rcvyDate: 'Claims Recovery Date Basis',
        frgnCurrRes: 'Permit Foreign Currency Reserve',
        protExRate: 'Protect Exchange Rate',
        prtRIOsRes: 'Print RI Oustanding Reserve',
        prtRIPV: 'Print RI Payment Voucher',
        permInsuffRes: 'Permit Payment with insufficient Reserves',
        nxtRevDateMand: 'Make Next Review Date Mandatory',
        autoFacXOLRcvy: 'Auto Recover Fac XOL',
        protAutoFacXOLRcvy: 'Protect Auto Fac XOL Recovery',
        gstCltGrp: 'GST Applicable Client Group',
        gstImpDate: 'GST Implementation Date',
        gstRegBlk: 'Enable GST Regulation 26 / 27',
        updGSTRegNo: 'Update GST Reg. No. on Name & Address',
        protGSTDIT: 'Protect GST Deemed Input Tax Rate',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        defDept: 'Default Department for Claims Payment'
      },
      miscCLForm: {
        clmNoForm: 0,
        impComDate: undefined,
        newClmPrtILN: undefined,
        resTranDate: undefined,
        setClmPrtILN: undefined,
        rcvyDate: undefined,
        frgnCurrRes: false,
        protExRate: false,
        prtRIOsRes: false,
        prtRIPV: false,
        permInsuffRes: undefined,
        nxtRevDateMand: false,
        autoFacXOLRcvy: false,
        protAutoFacXOLRcvy: false,
        gstCltGrp: undefined,
        gstImpDate: undefined,
        gstRegBlk: false,
        updGSTRegNo: false,
        protGSTDIT: false,
        modifiedName: this.$store.state.token.firstName,
        modifiedDate: new Date(),
        defDept: undefined
      },
      prtILNList: [
        { label: 'I - Immediate', value: 'I' },
        { label: 'L - Later', value: 'L' },
        { label: 'N - No', value: 'N' }
      ],
      rcvyDateList: [
        { label: 'P - Payment Voucher Date', value: 'P' },
        { label: 'S - System Date', value: 'S' }
      ],
      permInsuffResList: [
        { label: '1 - None', value: '1' },
        { label: '2 - Warning', value: '2' },
        { label: '3 - Error', value: '3' }
      ],
      gstCltGrpList: [
        { label: 'I - Individual', value: 'I' },
        { label: 'C - Corporate', value: 'C' }
      ],
      clmnoform: [],
      today: new Date(),
      submitting: false,
      query: true,
      tempStorage: [],
      defDeptList: []
    }
  },
  methods: {
    async doInit() {
      this.getCommonDataList('clmnoform')
      const apiURI = this.menu.getMiscCLParam
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.miscCLForm.clmNoForm = data.miscCLParam.clmNoForm
            this.miscCLForm.impComDate = data.miscCLParam.impComDate
            this.miscCLForm.newClmPrtILN = data.miscCLParam.newClmPrtILN
            this.miscCLForm.resTranDate = data.miscCLParam.resTranDate
            this.miscCLForm.setClmPrtILN = data.miscCLParam.setClmPrtILN
            this.miscCLForm.rcvyDate = data.miscCLParam.rcvyDate
            this.miscCLForm.frgnCurrRes = data.miscCLParam.frgnCurrRes
            this.miscCLForm.protExRate = data.miscCLParam.protExRate
            this.miscCLForm.prtRIOsRes = data.miscCLParam.prtRIOsRes
            this.miscCLForm.prtRIPV = data.miscCLParam.prtRIPV
            this.miscCLForm.permInsuffRes = data.miscCLParam.permInsuffRes
            this.miscCLForm.nxtRevDateMand = data.miscCLParam.nxtRevDateMand
            this.miscCLForm.autoFacXOLRcvy = data.miscCLParam.autoFacXOLRcvy
            this.miscCLForm.protAutoFacXOLRcvy = data.miscCLParam.protAutoFacXOLRcvy
            this.miscCLForm.gstCltGrp = data.miscCLParam.gstCltGrp
            this.miscCLForm.gstImpDate = data.miscCLParam.gstImpDate
            this.miscCLForm.gstRegBlk = data.miscCLParam.gstRegBlk
            this.miscCLForm.updGSTRegNo = data.miscCLParam.updGSTRegNo
            this.miscCLForm.protGSTDIT = data.miscCLParam.protGSTDIT
            this.miscCLForm.modifiedName = data.miscCLParam.modifiedName
            this.miscCLForm.modifiedDate = data.miscCLParam.modifiedDate
            this.miscCLForm.defDept = data.miscCLParam.defDept
            // Process deptList
            const departmentList = data.deptList
            if (departmentList) {
              departmentList.map((dept) => {
                const department = {
                  department: dept.value,
                  departmentDesc: dept.label,
                  departmentLabel: dept.value + ' - ' + dept.label
                }
                this.defDeptList.push(department)
              })
            }
          }
          this.tempStorage = clone(this.miscCLForm)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            // this.deptList = data.data.deptList
          }
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitting = true
          const apiURI = this.menu.saveMiscCLParam
          if (apiURI) {
            this.$http
              .post(apiURI, this.miscCLForm)
              .then((result) => {
                const { data } = result
                if (data) {
                  this.notify(data)
                  this.doInit()
                }
                this.submitting = false
              })
              .catch((err) => {
                this.submitting = false
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    },
    padString(value) {
      if (value) {
        return value.toString().padStart(4, '0')
      } else {
        return value
      }
    },
    async queryModeSwitch() {
      if (this.query === false) {
        this.toggleToTempStorage()
        this.query = true
      } else {
        this.query = false
      }
    },
    async toggleToTempStorage() {
      this.miscCLForm = this.tempStorage
      this.doInit()
    }
  },
  computed: {
    menu() {
      return this.$store.state.miscParams.menu
    }
  },
  created() {
    const checkDate = {
      getMessage: (field, args) => {
        return field + ' cannot be a future date'
      },
      validate: (value, args) => {
        if (value) {
          return !isAfter(removeTime(value), removeTime(new Date())) // || removeTime(value) >= removeTime(new Date())
        } else {
          return true
        }
      }
    }
    this.$validator.extend('checkDate', checkDate)
  },
  mixins: [MessageMixin, commonMixins, commonAjaxMixin]
}
</script>

<style>
</style>
